import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'
import classNames from 'classnames'

interface Props {
  onClose: () => void
  onConfirm: (params: {
    emailAddress: string
    optIn: boolean
  }) => void
  showOptIn: boolean
}

const emailRegExp = /^[^\s@]+@[^\s@]+$/

interface EmailListForm {
  emailAddress: string
  optIn: boolean
}

function isEmailValid(email: string): [boolean, boolean] {
  const isEmailEmpty = email.trim().length === 0
  const emailInvalid = !isEmailEmpty && emailRegExp.exec(email.trim()) === null

  return [isEmailEmpty, !emailInvalid]
}

const EmailListPopup: React.FunctionComponent<Props> = ({ onClose, onConfirm, showOptIn }) => {
  const [form, updateForm] = React.useReducer((state: EmailListForm, action: Partial<EmailListForm>) => {
    return {
      ...state,
      ...action,
    }
  }, {
    emailAddress: '',
    optIn: false,
  })

  const inputRef = React.useRef<HTMLInputElement | null>(null)

  React.useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const { emailAddress, optIn } = form

  const [isEmailEmpty, emailValid] = isEmailValid(emailAddress)

  const isFormValid = !isEmailEmpty && emailValid

  return (
    <Popup onClose={onClose}>
      <div className="title">
        Send a copy of your List via email
      </div>
      <form
        onSubmit={e => {
          e.preventDefault()

          onConfirm({
            emailAddress: emailAddress.trim(),
            optIn: showOptIn ? optIn : false,
          })
        }}
      >

        <input
          className={classNames({ invalid: !emailValid })}
          ref={inputRef}
          type="email"
          placeholder="Email address"
          value={emailAddress}
          onChange={e => updateForm({ emailAddress: e.target.value })}
        />

        <div style={{ marginBottom: '20px' }} />

        <div className="buttonRow">
          <Button
            buttonStyle="redStroke"
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button
            disabled={!isFormValid}
          >
            Send
          </Button>
        </div>
      </form>
    </Popup>
  )
}

export default EmailListPopup
